import { useQuery } from "react-query";
import { getCaixaById } from "../../services/api";

const useGetCaixaById = (userId, caixaId) => {
  return useQuery(["caixa", caixaId], () => getCaixaById(userId, caixaId), {
    enabled: !!caixaId,
    staleTime: 5 * 60 * 1000,   // 5 min - não refetch se dados recentes
    cacheTime: 10 * 60 * 1000,  // 10 min - manter no cache
  });
};

export default useGetCaixaById;
